import React from 'react';
import { Badge } from '../ui/badge';
import { useTranslation } from '../../hooks/useTranslation';

// Añadido más allá del pedido literal (que solo mencionaba status como
// columna de tabla) — mismo criterio visual que ScoreBadge/PriorityBadge,
// para no dejar el status como texto plano sin color en una tabla donde
// todo lo demás sí lo tiene.
const STATUS_STYLES = {
  NEW: 'bg-zinc-800 text-zinc-400 border-zinc-700',
  READY_TO_CONTACT: 'bg-sky-500/10 text-sky-400 border-sky-500/30',
  CONTACTED_WHATSAPP: 'bg-violet-500/10 text-violet-400 border-violet-500/30',
  CONTACTED_EMAIL: 'bg-violet-500/10 text-violet-400 border-violet-500/30',
  CONTACTED_CALL: 'bg-violet-500/10 text-violet-400 border-violet-500/30',
  FOLLOW_UP: 'bg-amber-500/10 text-amber-400 border-amber-500/30',
  DEMO_PENDING: 'bg-indigo-500/10 text-indigo-400 border-indigo-500/30',
  DEMO_SCHEDULED: 'bg-indigo-500/10 text-indigo-400 border-indigo-500/30',
  EVALUATING_PROPOSAL: 'bg-amber-500/10 text-amber-400 border-amber-500/30',
  CUSTOMER: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30',
  NOT_INTERESTED: 'bg-zinc-800 text-zinc-500 border-zinc-700',
  DISCARDED: 'bg-zinc-800 text-zinc-500 border-zinc-700',
  ERROR: 'bg-red-500/10 text-red-400 border-red-500/30',
};

export function StatusBadge({ status }) {
  const { t } = useTranslation();
  const key = STATUS_STYLES[status] ? status : 'NEW';

  return (
    <Badge variant="outline" className={STATUS_STYLES[key]}>
      {t(`aiLeadScanner.status.${key}`)}
    </Badge>
  );
}
